import styles from './controls-bar-space.module.scss';


const ControlsBarSpace = () => {
  return (
    <div className={styles.root} />
  )
}

export default ControlsBarSpace
